import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './CategoryDetails.css';

// Import the same jobs data from the Home Jobs component
import businessImage from '../../assets/business-ethics-01.png'
import mechanicImage from '../../assets/mechanic.png';
import accountingImage from '../../assets/accounting-book.png';
import salesImage from '../../assets/acquisition.png';
import tourismImage from '../../assets/information-desk_1044259-01.png';
import medicalImage from '../../assets/medical_13428098-01.png';
import engineerImage from '../../assets/worker.png';
import learningImage from '../../assets/student_17010263-01.png';
import beautyImage from '../../assets/best-product_7959966-01.png'

const jobsData = [
  {
    title: 'الوظائف الإدارية والقانونية',
    imgSrc: businessImage,
    altText: 'الوظائف الإدارية والقانونية'
  },
  {
    title: 'المبيعات',
    imgSrc: salesImage,
    altText: 'المبيعات'
  },
  {
    title: 'المحاسبة والتدقيق',
    imgSrc: accountingImage,
    altText: 'المحاسبة والتدقيق'
  },
  {
    title: 'المهن الحرفية',
    imgSrc: mechanicImage,
    altText: 'المهن الحرفية'
  },
  {
    title: 'السياحة والضيافة',
    imgSrc: tourismImage,
    altText: 'السياحة والضيافة'
  },
  {
    title: 'الطب والرعاية الصحية',
    imgSrc: medicalImage,
    altText: 'الطب والرعاية الصحية'
  },
  {
    title: 'الهندسة',
    imgSrc: engineerImage,
    altText: 'الهندسة'
  },
  {
    title: 'التدريس والشؤون الاكاديمية',
    imgSrc: learningImage,
    altText: 'التدريس والشؤون الاكاديمية'
  },
  {
    title: 'الجمال والموضة',
    imgSrc: beautyImage,
    altText: 'الجمال والموضة'
  }
];

const CategoryDetails = () => {
  const { category } = useParams();
  const [filteredJobs, setFilteredJobs] = useState([]);

  useEffect(() => {
    // Find the jobs with the matching title using the same logic as Jobs component
    const selectedJobs = jobsData.filter((job) =>
      job.title.toLowerCase().replace(/\s+/g, '-') === category
    );
    setFilteredJobs(selectedJobs);
  }, [category]);

  return (
    <div className="category-page">
      <div className="category-hero">
        <div className="container">
          <h2 className="category-title">
            {filteredJobs.length > 0 ? filteredJobs[0].title : 'المجال المطلوب'}
          </h2>
          <div className="title-line"></div>
          <p className="category-subtitle">
            اكتشف الفرص المتاحة في هذا المجال
          </p>
        </div>
      </div>

      <div className="category-content">
        <div className="container">
          {filteredJobs.length > 0 ? (
            <div className="jobs-grid">
              {filteredJobs.map((job, index) => (
                <div className="job-card" key={index}>
                  <div className="job-icon">
                    <img src={job.imgSrc} alt={job.altText} />
                  </div>
                  <div className="job-info">
                    <h5 className="job-title">{job.title}</h5>
                    <p className="job-description">
                      ابدأ رحلتك المهنية في هذا المجال المتميز
                    </p>
                    <button className="explore-btn">استكشف الفرص</button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-jobs">
              <div className="no-jobs-icon">🔍</div>
              <h3>لا توجد وظائف متاحة</h3>
              <p>عذراً، لا توجد وظائف متاحة في هذا المجال حالياً</p>
              <button className="back-btn">العودة للصفحة الرئيسية</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CategoryDetails;
